'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var isIpfs = require('is-ipfs');

var cid = require('multiformats/cid');

var key = require('interface-datastore/key');

var errCode = require('err-code');

var withTimeoutOption = require('ipfs-core-utils/with-timeout-option');

var toCidAndPath = require('ipfs-core-utils/to-cid-and-path');

var dagPB = require('@ipld/dag-pb');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var isIpfs__default = /*#__PURE__*/_interopDefaultLegacy(isIpfs);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

var dagPB__namespace = /*#__PURE__*/_interopNamespace(dagPB);

var ERR_BAD_PATH = 'ERR_BAD_PATH';
var OFFLINE_ERROR = 'This command must be run in online mode. Try running \'ipfs daemon\' first.';
var MFS_ROOT_KEY = new key.Key('/local/filesroot');
var MFS_MAX_CHUNK_SIZE = 262144;
var MFS_MAX_LINKS = 174;

var normalizePath = function normalizePath(pathStr) {
  var cid$1 = cid.CID.asCID(pathStr);

  if (cid$1) {
    return "/ipfs/".concat(pathStr);
  }

  var str = pathStr.toString();

  try {
    return "/ipfs/".concat(cid.CID.parse(str));
  } catch (_unused) {}

  if (isIpfs__default["default"].path(str)) {
    return str;
  } else {
    throw errCode__default["default"](new Error("invalid path: ".concat(pathStr)), ERR_BAD_PATH);
  }
};

var normalizeCidPath = function normalizeCidPath(path) {
  if (path instanceof Uint8Array) {
    return cid.CID.decode(path).toString();
  }

  path = path.toString();

  if (path.indexOf('/ipfs/') === 0) {
    path = path.substring('/ipfs/'.length);
  }

  if (path.charAt(path.length - 1) === '/') {
    path = path.substring(0, path.length - 1);
  }

  return path;
};

var resolvePath = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(repo, codecs, ipfsPath) {
    var options,
        _toCidAndPath$toCidAn,
        cid$1,
        path,
        lastCid,
        lastRemainderPath,
        _iteratorAbruptCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        _step$value,
        value,
        remainderPath,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 3 && _args[3] !== undefined ? _args[3] : {};
            _toCidAndPath$toCidAn = toCidAndPath.toCidAndPath(ipfsPath), cid$1 = _toCidAndPath$toCidAn.cid, path = _toCidAndPath$toCidAn.path;

            if (path) {
              options.path = path;
            }

            lastCid = cid$1;
            lastRemainderPath = options.path || '';

            if (lastRemainderPath.startsWith('/')) {
              lastRemainderPath = lastRemainderPath.substring(1);
            }

            if (!options.path) {
              _context.next = 45;
              break;
            }

            _context.prev = 7;
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 10;
            _iterator = _asyncIterator(resolve(cid$1, options.path, codecs, repo, {
              signal: options.signal
            }));

          case 12:
            _context.next = 14;
            return _iterator.next();

          case 14:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 23;
              break;
            }

            _step$value = _step.value, value = _step$value.value, remainderPath = _step$value.remainderPath;

            if (cid.CID.asCID(value)) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("break", 23);

          case 18:
            lastRemainderPath = remainderPath;
            lastCid = value;

          case 20:
            _iteratorAbruptCompletion = false;
            _context.next = 12;
            break;

          case 23:
            _context.next = 29;
            break;

          case 25:
            _context.prev = 25;
            _context.t0 = _context["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 29:
            _context.prev = 29;
            _context.prev = 30;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 34;
              break;
            }

            _context.next = 34;
            return _iterator.return();

          case 34:
            _context.prev = 34;

            if (!_didIteratorError) {
              _context.next = 37;
              break;
            }

            throw _iteratorError;

          case 37:
            return _context.finish(34);

          case 38:
            return _context.finish(29);

          case 39:
            _context.next = 45;
            break;

          case 41:
            _context.prev = 41;
            _context.t1 = _context["catch"](7);

            if (_context.t1.message.startsWith('Object has no property')) {
              _context.t1.message = "no link named \"".concat(lastRemainderPath.split('/')[0], "\" under ").concat(lastCid);
              _context.t1.code = 'ERR_NO_LINK';
            }

            throw _context.t1;

          case 45:
            return _context.abrupt("return", {
              cid: lastCid,
              remainderPath: lastRemainderPath || ''
            });

          case 46:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 41], [10, 25, 29, 39], [30,, 34, 38]]);
  }));

  return function resolvePath(_x6, _x7, _x8) {
    return _ref2.apply(this, arguments);
  };
}();

var mapFile = function mapFile(file) {
  if (file.type !== 'file' && file.type !== 'directory' && file.type !== 'raw') {
    throw new Error("Unknown node type '".concat(file.type, "'"));
  }

  var output = {
    cid: file.cid,
    path: file.path,
    name: file.name,
    size: file.size,
    type: 'file'
  };

  if (file.type === 'directory') {
    output.type = 'dir';
  }

  if (file.type === 'file') {
    output.size = file.unixfs.fileSize();
  }

  if (file.type === 'file' || file.type === 'directory') {
    output.mode = file.unixfs.mode;

    if (file.unixfs.mtime !== undefined) {
      output.mtime = file.unixfs.mtime;
    }
  }

  return output;
};

var withTimeout = withTimeoutOption.withTimeoutOption( /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(promise, _options) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return promise;

          case 2:
            return _context2.abrupt("return", _context2.sent);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function (_x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}());

var resolve = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cid$1, path, codecs, repo, options) {
    var load, parts, value, lastCid, _loop, _ret;

    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            load = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cid) {
                var codec, block;
                return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                  while (1) {
                    switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return codecs.getCodec(cid.code);

                      case 2:
                        codec = _context3.sent;
                        _context3.next = 5;
                        return repo.blocks.get(cid, options);

                      case 5:
                        block = _context3.sent;
                        return _context3.abrupt("return", codec.decode(block));

                      case 7:
                      case "end":
                        return _context3.stop();
                    }
                  }
                }, _callee3);
              }));

              return function load(_x11) {
                return _ref4.apply(this, arguments);
              };
            }();

            parts = path.split('/').filter(Boolean);
            _context5.next = 4;
            return _awaitAsyncGenerator(load(cid$1));

          case 4:
            value = _context5.sent;
            lastCid = cid$1;

            if (parts.length) {
              _context5.next = 9;
              break;
            }

            _context5.next = 9;
            return {
              value: value,
              remainderPath: ''
            };

          case 9:
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var key, link;
              return _regeneratorRuntime.wrap(function _loop$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      key = parts.shift();

                      if (key) {
                        _context4.next = 3;
                        break;
                      }

                      throw errCode__default["default"](new Error("Could not resolve path \"".concat(path, "\"")), 'ERR_INVALID_PATH');

                    case 3:
                      if (!(cid$1.code === dagPB__namespace.code && Array.isArray(value.Links))) {
                        _context4.next = 13;
                        break;
                      }

                      link = value.Links.find(function (l) {
                        return l.Name === key;
                      });

                      if (!link) {
                        _context4.next = 13;
                        break;
                      }

                      _context4.next = 8;
                      return {
                        value: link.Hash,
                        remainderPath: parts.join('/')
                      };

                    case 8:
                      _context4.next = 10;
                      return _awaitAsyncGenerator(load(link.Hash));

                    case 10:
                      value = _context4.sent;
                      lastCid = link.Hash;
                      return _context4.abrupt("return", "continue");

                    case 13:
                      if (!Object.prototype.hasOwnProperty.call(value, key)) {
                        _context4.next = 19;
                        break;
                      }

                      value = value[key];
                      _context4.next = 17;
                      return {
                        value: value,
                        remainderPath: parts.join('/')
                      };

                    case 17:
                      _context4.next = 20;
                      break;

                    case 19:
                      throw errCode__default["default"](new Error("no link named \"".concat(key, "\" under ").concat(lastCid)), 'ERR_NO_LINK');

                    case 20:
                      if (!cid.CID.asCID(value)) {
                        _context4.next = 25;
                        break;
                      }

                      lastCid = value;
                      _context4.next = 24;
                      return _awaitAsyncGenerator(load(value));

                    case 24:
                      value = _context4.sent;

                    case 25:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _loop);
            });

          case 10:
            if (!parts.length) {
              _context5.next = 17;
              break;
            }

            return _context5.delegateYield(_loop(), "t0", 12);

          case 12:
            _ret = _context5.t0;

            if (!(_ret === "continue")) {
              _context5.next = 15;
              break;
            }

            return _context5.abrupt("continue", 10);

          case 15:
            _context5.next = 10;
            break;

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4);
  }));

  return function resolve(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();

exports.MFS_MAX_CHUNK_SIZE = MFS_MAX_CHUNK_SIZE;
exports.MFS_MAX_LINKS = MFS_MAX_LINKS;
exports.MFS_ROOT_KEY = MFS_ROOT_KEY;
exports.OFFLINE_ERROR = OFFLINE_ERROR;
exports.mapFile = mapFile;
exports.normalizeCidPath = normalizeCidPath;
exports.normalizePath = normalizePath;
exports.resolve = resolve;
exports.resolvePath = resolvePath;
exports.withTimeout = withTimeout;